import React from 'react';
import { RULES, EXAMPLE } from '../../utils/passwordPolicy';

/**
 * The password rules, shown under the password field and ticking off live as
 * the shopper types.
 *
 * Nothing in the signup UI used to state that a capital letter and a number
 * were required, so the first time anyone heard about it was a rejection — and
 * the rejection arrived on the OTP screen, where it read as a bad OTP. Showing
 * the rules up front is the actual fix; the API checks are the backstop.
 */
const PasswordRequirements = ({ value = '', className = '' }) => {
  const password = value || '';
  const touched = password.length > 0;

  return (
    <div className={`mt-2 ${className}`}>
      <ul className="space-y-1">
        {RULES.map((rule) => {
          const passed = rule.test(password);
          return (
            <li
              key={rule.id}
              className={`flex items-center text-xs ${
                !touched ? 'text-gray-500' : passed ? 'text-green-600' : 'text-gray-500'
              }`}
            >
              <span
                aria-hidden="true"
                className={`mr-2 flex h-3.5 w-3.5 flex-shrink-0 items-center justify-center rounded-full text-[9px] font-bold ${
                  touched && passed ? 'bg-green-100 text-green-600' : 'bg-gray-100 text-gray-400'
                }`}
              >
                {touched && passed ? '✓' : '•'}
              </span>
              {rule.label}
            </li>
          );
        })}
      </ul>
      <p className="mt-1.5 text-xs text-gray-400">
        Example: <span className="font-medium text-gray-500">{EXAMPLE}</span>
      </p>
    </div>
  );
};

export default PasswordRequirements;
